
define('modules/application/wizard/steps/materialOverview/energyManagementMaterialOverview',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",

  "plugins/backbone.memento",

  //Class
  "../regularStep",
  "../../../popup",
  "../../classes/genericIncrementalElement"
],

function(app, Backbone, jQueryUi, Memento, RegularStep, Popup, genericIncrementalElement) {

  //Creating an event aggragatop
  var MaterialOverviewEventAggregator    = _.extend({}, Backbone.Events);

  var optionalPackageModel               = Backbone.Model.extend({
    initialize           : function() {
      this.getProducts();
    },

    addProductAttributes : function(product) {
      BticinoS4B.Instances.Models.ApplicationModel.getProducts(product.packageClassId, function(data) {
        data.products                 = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
        var mainProduct               = _.filter(data.products, function(current){return current.mnemonic===1;})[0];
        mainProduct.secondaryProducts = [];
        var secondaryProducts         = _.filter(data.products, function(current){return current.mnemonic!==1;});

        mainProduct.secondaryProducts = secondaryProducts;
        _.extend(product, mainProduct);
      });
    },

    getProducts          : function() {
      var products        = this.get("products").packagesByOptionalPackageId;
      var productsLength  = products.length;

      for(var i=0; i<productsLength; i++) {
        this.addProductAttributes(products[i]);
      }
    },

    requestShow          : function() {
      this.get("products").view.show();
    },

    reset                : function() {
      var products       = this.get("products").packagesByOptionalPackageId;
      var productsLength = products.length;

      for (var i=0; i<productsLength; i++) {
        products[i].set("value", 0);
      }
    },

    //Exception for cameras
    trafoFoundChangedEventHandler : function() {
      var trafoFound = BticinoS4B.Instances.Models.ApplicationModel.get("trafoFound");
      if(!trafoFound)
        this.set("notShowable", true);
      else
        this.set("notShowable", false);
    }
  });

  var optionalPackageView                = Backbone.View.extend({
    className : "optional",
    template  : "application/wizard/steps/optionalPackage",
    tagName   : "section",
    events    : {
      "click .openSection" : "show"
    },
    initialize                            : function()  {
      this.model.view=this;
    },
    serialize                             : function()  {return {model:this.model, app : BticinoS4B.Instances.Models.ApplicationModel};},
    show                                  : function()  {
      _.extend(this.model, {title : this.model.wizardChoiceLabel});
      this.productsView = new optionalProductsView({model : this.model});
      this.insertView(this.productsView, this);
      this.render();

      var requestRestore = function() {
        var that = this;
        $("#cboxClose", function(){
          that.restoreRequired = true;
        });
      };

      var restoreIfRequired = function() {
        if (this.restoreRequired)
        {
          var optionalProducts       = this.model.packagesByOptionalPackageId;
          var optionalProductsLength = optionalProducts.length;

          for (var i=0; i<optionalProductsLength; i++)
            optionalProducts[i].memento.restore();

          this.restoreRequired = false;
        }
      };

      this.productsView.show(requestRestore, restoreIfRequired, this);
    }
  });

  var optionalProductModel               = genericIncrementalElement.Model.extend({
    defaults   : _.extend({}, genericIncrementalElement.Model.prototype.defaults, {
      enabled : true,
      value   : 0
    }),

    initialize                : function() {
      this.set("specialVars", $.parseJSON(this.get('specialVars')));

      //Setting max value if present in specialVars
      if(this.get('specialVars') && this.get('specialVars').maxOptionalItem)
      {
        this.set('maxValue', this.get('specialVars').maxOptionalItem);
      }

      this.memento = new Backbone.Memento(this);
      this.bind("change:value", this.valueChangedEventHandler, this);
    },

    valueChangedEventHandler  : function() {
      window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
    }

  });

  var optionalProductView                = genericIncrementalElement.Views.content.extend({
    className : "optionalProduct",
    tagName   : "li",
    template  : "application/popups/optionalProduct"
  });

  var optionalProductsView               = Popup.View.extend({
    className : "popup optionalProducts",
    template  : "application/popups/optionalProducts",
    serialize              : function() {return {model:this.model};},
    initialize             : function() {
      if (this.model.packagesByOptionalPackageId)
      {
        var optionalProducts       = this.model.packagesByOptionalPackageId;
        var optionalProductsLength = optionalProducts.length;

        for (var i=0; i<optionalProductsLength; i++)
        {
          if (!optionalProducts[i].attributes)
            optionalProducts[i] = new optionalProductModel(optionalProducts[i]);

          //Store the current state of the model
          optionalProducts[i].memento.store();
          this.insertView(".optionalProducts", new optionalProductView({model : optionalProducts[i]}));
        }
      }
    },

    hide                   : function() {
      this.model.get("stepEventAggregator").trigger("recalculation:request");
      this.remove();
    }
  });

  var materialOverviewViews              = _.extend({},RegularStep.Views);

  _.extend(materialOverviewViews, {

    Content             : RegularStep.Views.Content.extend({
      template              : "application/wizard/steps/material-overview",
      events                : {
        "click .goToZoneButton"                 : "requestZoneVisualizationEventHandler",
        "click .goToOptionalPackage"            : "requestOptionalPackageVisualizationEventHandler",
        "click .deleteOptionalPackageProducts"  : "deleteOptionalPackageProductsEventHandler",
        "click .confirm-button"                 : "confirmButtonClicked",
        "click .material-list-button"           : "materialListButtonClicked"
      },

      serialize                                       : function() {
        return { model : this.model, app: BticinoS4B.Instances.Models.ApplicationModel, dataProvider : BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider") };
      },

      cleanup                                         : function() {
        this.model.off(null, null, this);
      },

      initialize                                      : function() {
        var that                  = this;

        var MaterialListView      = Popup.View.extend({
          className   : "popup material-list",
          template    : "application/popups/material-list",
          serialize   :  function() {
            return { model : this.model, app: BticinoS4B.Instances.Models.ApplicationModel, dataProvider : BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider") };
          },

          show        : function() {

            var that         = this;
            this.content     = this.$el.html();
            var colorBoxdata = {
              html        :this.content,
              scrolling   :  false,
              transition  :  "none",
              close       :  "",
              opacity     :  0.6,
              speed       :  150,
              overlayClose:  false,
              escKey      :  false,
              width       :  "83%",
              height      :  "50%",

              onComplete:function() {
                $(".closeButton").click(function(){that.closeButtonClickedEventHandler();});
              },

              onClosed :function() {
                if (that.model.get("callback")!==undefined)
                  that.model.get("callback").apply(window.location);
              }
            };

            if (this.model.get("closeButton")===false)
              _.extend(colorBoxdata, {onLoad: function() {$('#cboxClose').hide();}});
            else
              _.extend(colorBoxdata, {onLoad: function() {$('#cboxClose').show();}});

            $.colorbox(colorBoxdata);
            this.resize();

            $(window).unbind('resize', this.resize);
            $(window).bind('resize', this.resize);
          },

          deliverModel : function() {
          switch (BticinoS4B.vars.system.id) {
            case '#2':
              BticinoS4B.solution.thermoregulation.optionalPackages = this.model;
              break;
            case '#4':
              BticinoS4B.solution.intrusionDetection.optionalPackages = this.model;
              break;
            case '#5+6':
              BticinoS4B.solution.audioVideo.optionalPackages = this.model;
              break;
            case '#13+20':
              BticinoS4B.solution.automation.optionalPackages = this.model;
              break;
            case '#13':
              BticinoS4B.solution.automationSimple.optionalPackages = this.model;
              break;
            case '#21':
              BticinoS4B.solution.energyManagement.optionalPackages = this.model;
              break;
          }
            BticinoS4B.Instances.Models.ApplicationModel.set("optionalPackages", this.model);
          },

          resize      : function() {
            $.colorbox.resize();
          }
        });

        //Creating popups
        var materialListViewModel = _.extend({}, BticinoS4B.Instances.Models.ApplicationModel);

        _.extend(materialListViewModel.attributes, {quote : "IDS_W1_9021"});
        this.loader               = new window.BticinoS4B.Instances.Views.LoaderView({
          model       :  {
            quote : "IDS_W1_9095",
            closeButton : false
          }
        });

        this.materialList         = new MaterialListView({
          model       :  materialListViewModel,
          quote       : "IDS_W1_9021"
        });

        //Binding events
        this.model.get("stepEventAggregator").unbind("recalculation:request",this.recalculate);
        this.model.get("stepEventAggregator").bind("recalculation:request",this.recalculate, this);

        this.model.get("stepEventAggregator").unbind("recalculation:complete",this.render);
        this.model.get("stepEventAggregator").bind("recalculation:complete",this.render, this);

        this.options.stepEventAggregator.bind('confirmButton:clicked', function()  {
          if (that.isValid())
            this.trigger("step:validated", that.model);
          else
            this.trigger("step:unvalidated", that.model);
        });
      },

      showRequestedEventHandler                       : function(packageId) {
        var optionalPackages       = this.model.get("optionalPackages");
        var optionalPackagesLength = optionalPackages.length;
      },

      materialListButtonClicked                       : function(e){
        this.materialList.show();
      },

      confirmButtonClicked                            : function(e){
        this.model.get("stepEventAggregator").trigger("confirmButton:clicked");
        e.preventDefault();
      },

      recalculate                                     : function() {
        this.loader.show(this.requestRecalculation, this.render, this);
      },

      requestRecalculation                            : function() {
        BticinoS4B.Instances.Models.ApplicationModel.startAutomaticCalculation();
        this.recalculationCompletedEventHandler();
      },

      recalculationCompletedEventHandler              : function() {
        this.loader.hide();
      },

      verifyZoneValidation                            : function() {
        return true;
      },

      isValid                                         : function() {
        return true;
      },

      requestZoneVisualizationEventHandler            : function(e){
        var requestedZoneNumber = Number($(e.target).attr("id").replace("#",""));
        window.BticinoS4B.eventAggregator.trigger("zone:selectionRequested", requestedZoneNumber);
        window.BticinoS4B.eventAggregator.trigger("zoneStep:show");
      },

      requestOptionalPackageVisualizationEventHandler : function(e) {
        var requestedOptionalPackageId = $(e.currentTarget).attr("id").replace("g","");
        this.model.get("stepEventAggregator").trigger("showOptionalPackage:requested", requestedOptionalPackageId);
      },

      deleteOptionalPackageProductsEventHandler       : function(e) {
        var requestedOptionalPackageId = $(e.currentTarget).attr("id").replace("d","");
        this.model.get("stepEventAggregator").trigger("deleteOptionalPackageProducts:requested", requestedOptionalPackageId);
      },

      beforeRender                                    : function() {
        this.insertView(".popups", this.loader);
        this.insertView(".popups", this.materialList);

        var i=0, product, grandTotal=0, optionalPackage;
        var externalItems       = BticinoS4B.Instances.Models.ApplicationModel.get("automaticProducts")  ? BticinoS4B.Instances.Models.ApplicationModel.get("automaticProducts").externalItems : [];
        var zonesItems          = BticinoS4B.Instances.Models.ApplicationModel.get("zonesItems");
        var optionalPackages    = BticinoS4B.Instances.Models.ApplicationModel.get("optionalPackages");
        var automaticItems      = BticinoS4B.Instances.Models.ApplicationModel.get("automaticProducts")  ? BticinoS4B.Instances.Models.ApplicationModel.get("automaticProducts").automaticItems : [];
        var configurationItems  = BticinoS4B.Instances.Models.ApplicationModel.get("configurationModel") ? BticinoS4B.Instances.Models.ApplicationModel.get("configurationModel").itemsConfiguratorAdded : [];

        var retrieveProductCode   = function(item)      {return item.productCode;};
        var checkNonZeroQuantity  = function(item)      {return item.quantity>0;};
        var sumQuantities         = function(memo, item){
          return memo + item.quantity;
        };

        if(optionalPackages) {
          var stepEventAggregator    = this.model.get("stepEventAggregator");
          var optionalPackagesLength = optionalPackages.length;
          for (i=0; i<optionalPackagesLength; i++) {

            optionalPackage = optionalPackages[i];
            if(!optionalPackage.get("notShowable"))
              this.insertView(".optionalPackages", new optionalPackageView({
                model : _.extend(optionalPackage.get("products"), {
                  stepEventAggregator : stepEventAggregator
                })
              }));
          }
        }

        /*Filtering for quantity*/
        if (externalItems) {
          externalItems = _.filter(externalItems, function(item) {
            return (item.quantity>0);
          });

          /*Grouping products*/
          externalItems = _.groupBy(externalItems, retrieveProductCode);

          /*Sum quantities*/
          for (product in externalItems)
            externalItems[product][0].totalQuantity       = _.reduce(externalItems[product], sumQuantities, 0.00);
        }

        /*Grand total calculation*/
        if(externalItems)
          for (product in externalItems)
            grandTotal += (externalItems[product][0].totalQuantity ? externalItems[product][0].totalQuantity : externalItems[product][0].quantity)*(externalItems[product][0].price ? externalItems[product][0].price : 0);

        if (zonesItems)
          for (i=0; i<zonesItems.length; i++)
            for (product in zonesItems[i].items) {
              if((zonesItems[i].items[product])&&(zonesItems[i].items[product][0].productCode)&&(zonesItems[i].items[product][0].productCode.indexOf("__ND__")!==0))
                grandTotal += (zonesItems[i].items[product][0].totalQuantity ? zonesItems[i].items[product][0].totalQuantity : zonesItems[i].items[product][0].quantity)*(zonesItems[i].items[product][0].price ? zonesItems[i].items[product][0].price : 0);
              else
                delete zonesItems[i].items[product];
            }

        if(automaticItems)
          for (i=0; i<automaticItems.length; i++)
            grandTotal += automaticItems[i].quantity*(automaticItems[i].price ? automaticItems[i].price : 0);

        if(configurationItems)
          for (i=0; i<configurationItems.length; i++)
            grandTotal += configurationItems[i].quantity*(configurationItems[i].price ? configurationItems[i].price : 0);

        var tempPrice         = 0,
            secondaryProducts = [],
            currentPackage;
        var secondaryProductsGroupingFunction = function(product){return product.productCode;};

        if (optionalPackages)
          for (i=0; i<optionalPackages.length; i++)
          {
            optionalPackage = optionalPackages[i];
            if ((optionalPackage)&&(!optionalPackage.get("notShowable")))
            {
              for (j=0; j<optionalPackage.get("products").packagesByOptionalPackageId.length; j++)
              {
                currentPackage = optionalPackage.get("products").packagesByOptionalPackageId[j];
                if (currentPackage.attributes)
                {
                  tempPrice   = currentPackage.get("price")*currentPackage.get("value");
                  grandTotal += (!isNaN(tempPrice)) ? tempPrice : 0;
                }
                else
                {
                  tempPrice   = currentPackage.price*currentPackage.value;
                  grandTotal += (!isNaN(tempPrice)) ? tempPrice : 0;
                }

                if (currentPackage.attributes)
                {
                  if (currentPackage.get("secondaryProducts"))
                    secondaryProducts = _.groupBy(currentPackage.get("secondaryProducts"), secondaryProductsGroupingFunction);
                }
                else if (currentPackage.secondaryProducts)
                    secondaryProducts = _.groupBy(currentPackage.secondaryProducts, secondaryProductsGroupingFunction);

                if ( ((currentPackage.attributes)&&(currentPackage.get("value")>0)) || (currentPackage.value>0) )
                {
                  for (var group in secondaryProducts)
                  {
                    if (typeof secondaryProducts[group] !== "function")
                    {
                      tempPrice   = secondaryProducts[group][0].price*(currentPackage.attributes ? currentPackage.get("value") : currentPackage.value);
                      grandTotal += (!isNaN(tempPrice)) ? tempPrice : 0;
                    }
                  }
                }
              }
            }
          }

        this.model.set("grandTotal",          grandTotal);
        BticinoS4B.Instances.Models.ApplicationModel.set("grandTotal",           grandTotal);
        this.model.set("externalItems",       externalItems);
        this.model.set("zonesItems",          zonesItems);
        this.model.set("automaticItems",      automaticItems);
        this.model.set("configurationItems",  configurationItems);
      },

      afterRender                                     : function() {

        //Instancing footer if necessary
        if (this.model.get("gotConfirm")===true)
        {
          this.model.set("quote", "IDS_W1_9013");
          //this.insertView(new RegularStep.Views.Confirm({ model   :   this.model  }));
        }

        var pageContent     = $(this.el).find(".itemContent");
        var topBarSection   = $(this.el).find(".topBar");
        var confirmSection  = $(this.el).find("footer");
        var wizardSection   = $('#wizard').height()-$('#stepList').height()-25;
        var genericInfoView = this.$el.find(".genericInfo");

        if(confirmSection.length>0)
          pageContent.css("height", (wizardSection-genericInfoView.height()-topBarSection.height()-confirmSection.height()-44)+"px");
        else
          pageContent.css("height", (wizardSection-genericInfoView.height()-topBarSection.height()-44)+"px");

        $(this.el).find("h3 .titleBarcontent span").corner("2px");
        $(this.el).find(".accordionView").accordion({collapsible: true, active: 0, autoHeight: false });
        //$(this.el).find(".accordionView").mCustomScrollbar({advanced:{updateOnContentResize: true}});
      }
    })
  });

  //Creating a model with a collection of MaterialOverview
  var materialOverviewModel              = Backbone.Model.extend({

    initialize          : function () {
      window.BticinoS4B.eventAggregator.unbind("modelDeliver:request",                                this.deliverModel);
      window.BticinoS4B.eventAggregator.bind("modelDeliver:request",                                  this.deliverModel,                        this);

      window.BticinoS4B.eventAggregator.unbind("materialsOverview:requested",                         this.tabShowEventHandler);
      window.BticinoS4B.eventAggregator.bind("materialsOverview:requested",                           this.tabShowEventHandler,                 this);

      window.BticinoS4B.eventAggregator.unbind("load:Project",                                        this.loadProject);
      window.BticinoS4B.eventAggregator.bind("load:Project",                                          this.loadProject,                         this);

      window.BticinoS4B.eventAggregator.unbind("currentDeliver:requested",                            this.deliverCurrent);
      window.BticinoS4B.eventAggregator.bind("currentDeliver:requested",                              this.deliverCurrent,                      this);

      window.BticinoS4B.eventAggregator.unbind("accessoryLine:chosen",                                this.accessoryLineChosenEventHandler);
      window.BticinoS4B.eventAggregator.bind("accessoryLine:chosen",                                  this.accessoryLineChosenEventHandler,     this);

      this.get("stepEventAggregator").unbind("showOptionalPackage:requested",           this.showRequestedOptionalPackage);
      this.get("stepEventAggregator").bind("showOptionalPackage:requested",             this.showRequestedOptionalPackage,        this);

      this.get("stepEventAggregator").unbind("deleteOptionalPackageProducts:requested", this.deleteOptionalPackageProducts);
      this.get("stepEventAggregator").bind("deleteOptionalPackageProducts:requested",   this.deleteOptionalPackageProducts,       this);

      window.BticinoS4B.eventAggregator.unbind("configurators:addedFromKit",                          this.configuratorsAddedFromKit);
      window.BticinoS4B.eventAggregator.bind("configurators:addedFromKit",                            this.configuratorsAddedFromKit,           this);

      window.BticinoS4B.eventAggregator.unbind("powerSupply:addedFromKit",                            this.powerSupplyAddedFromKit);
      window.BticinoS4B.eventAggregator.bind("powerSupply:addedFromKit",                              this.powerSupplyAddedFromKit,           this);

      window.BticinoS4B.eventAggregator.unbind("keyCover:addedFromKit",                               this.keyCoverAddedFromKit);
      window.BticinoS4B.eventAggregator.bind("keyCover:addedFromKit",                                 this.keyCoverAddedFromKit,           this);
      
      window.BticinoS4B.eventAggregator.trigger("accessoryLine:chosen");
    },

    configuratorsAddedFromKit       : function(addedConfigurators) {
      var configurationProductsFromKit = BticinoS4B.Instances.Models.ApplicationModel.get("configurationProductsFromKit") ? BticinoS4B.Instances.Models.ApplicationModel.get("configurationProductsFromKit") : [];
      configurationProductsFromKit.push({
        packageClassId : addedConfigurators.packageClassId,
        quantity       : addedConfigurators.quantity
      });
      var retrieveMainProducts      = function(product) {return (product.mnemonic===1);},
          retrieveSecondaryProducts = function(product) {return (product.mnemonic!==1);},
          mergeDatas                = function(data) {
            _.extend(configurationProductsFromKit[i], _.filter(data.products, retrieveMainProducts)[0]);
            var secondaryProducts = _.filter(data.products,retrieveSecondaryProducts);
            configurationProductsFromKit[i].secondaryProducts = secondaryProducts;
          };

      for (var i = configurationProductsFromKit.length - 1; i >= 0; i--)
        BticinoS4B.Instances.Models.ApplicationModel.getProducts(configurationProductsFromKit[i].packageClassId, mergeDatas, false);

      BticinoS4B.Instances.Models.ApplicationModel.set("configurationProductsFromKit", configurationProductsFromKit);
    },

    powerSupplyAddedFromKit       : function(addedPowerSupply) {
      var powerSuppliesFromKit = BticinoS4B.Instances.Models.ApplicationModel.get("powerSuppliesFromKit") ? BticinoS4B.Instances.Models.ApplicationModel.get("powerSuppliesFromKit") : [];
      powerSuppliesFromKit.push(addedPowerSupply);
      var retrieveMainProducts      = function(product) {return (product.mnemonic===1);},
          retrieveSecondaryProducts = function(product) {return (product.mnemonic!==1);},
          mergeDatas                = function(data) {
            _.extend(powerSuppliesFromKit[i], _.filter(data.products, retrieveMainProducts)[0]);
            var secondaryProducts = _.filter(data.products,retrieveSecondaryProducts);
            powerSuppliesFromKit[i].secondaryProducts = secondaryProducts;
          };

      for (var i = powerSuppliesFromKit.length - 1; i >= 0; i--)
        BticinoS4B.Instances.Models.ApplicationModel.getProducts(powerSuppliesFromKit[i].packageClassId, mergeDatas, false);

      BticinoS4B.Instances.Models.ApplicationModel.set("powerSuppliesFromKit", powerSuppliesFromKit);
    },

    keyCoverAddedFromKit       : function(addedKeyCover) {
      var keyCoversFromKit = BticinoS4B.Instances.Models.ApplicationModel.get("keyCoversFromKit") ? BticinoS4B.Instances.Models.ApplicationModel.get("keyCoversFromKit") : [];
      keyCoversFromKit.push(addedKeyCover);
      var retrieveMainProducts      = function(product) {return (product.mnemonic===1);},
          retrieveSecondaryProducts = function(product) {return (product.mnemonic!==1);},
          mergeDatas                = function(data) {
            _.extend(keyCoversFromKit[i], _.filter(data.products, retrieveMainProducts)[0]);
            var secondaryProducts = _.filter(data.products,retrieveSecondaryProducts);
            keyCoversFromKit[i].secondaryProducts = secondaryProducts;
          };

      for (var i = keyCoversFromKit.length - 1; i >= 0; i--)
        BticinoS4B.Instances.Models.ApplicationModel.getProducts(keyCoversFromKit[i].packageClassId, mergeDatas, false);
      
          switch (BticinoS4B.vars.system.id) {
            case '#2':
              BticinoS4B.solution.thermoregulation.keyCoversFromKit = keyCoversFromKit;
              break;
            case '#4':
              BticinoS4B.solution.intrusionDetection.keyCoversFromKit = keyCoversFromKit;
              break;
            case '#5+6':
              BticinoS4B.solution.audioVideo.keyCoversFromKit = keyCoversFromKit;
              break;
            case '#13+20':
              BticinoS4B.solution.automation.keyCoversFromKit = keyCoversFromKit;
              break;
            case '#13':
              BticinoS4B.solution.automationSimple.keyCoversFromKit = keyCoversFromKit;
              break;
            case '#21':
              BticinoS4B.solution.energyManagement.keyCoversFromKit = keyCoversFromKit;
              break;
          }
      BticinoS4B.Instances.Models.ApplicationModel.set("keyCoversFromKit", keyCoversFromKit);
    },

    deliverModel        : function()  {
      var dataProvider           = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider"),
          optionalPackages       = this.get("optionalPackages"),
          optionalPackagesLength = optionalPackages ? optionalPackages.length : 0,
          itemsToSend            = [],
          itemToPush;

          switch (BticinoS4B.vars.system.id) {
            case '#2':
              BticinoS4B.solution.thermoregulation.optionalPackages = this.get("optionalPackages");
              break;
            case '#4':
              BticinoS4B.solution.intrusionDetection.optionalPackages = this.get("optionalPackages");
              break;
            case '#5+6':
              BticinoS4B.solution.audioVideo.optionalPackages = this.get("optionalPackages");
              break;
            case '#13+20':
              BticinoS4B.solution.automation.optionalPackages = this.get("optionalPackages");
              break;
            case '#13':
              BticinoS4B.solution.automationSimple.optionalPackages = this.get("optionalPackages");
              break;
            case '#21':
              BticinoS4B.solution.energyManagement.optionalPackages = this.get("optionalPackages");
              break;
          }
      BticinoS4B.Instances.Models.ApplicationModel.set("optionalPackages", this.get("optionalPackages"));

      for(var i=0; i<optionalPackagesLength; i++)
      {
        for(var j=0; j<optionalPackages[i].get("products").packagesByOptionalPackageId.length; j++)
        {
          itemToPush = optionalPackages[i].get("products").packagesByOptionalPackageId[j];
          if (itemToPush.attributes)
          itemsToSend.push({
            productCode       : itemToPush.get("productCode"),
            productLabel      : itemToPush.get("productLabel"),
            packageClassLabel : itemToPush.get("packageClassLabel"),
            kitValue          : itemToPush.get("kitValue"),
            partOfKit         : itemToPush.get("partOfKit"),
            quantity          : itemToPush.get("value"),
            price             : itemToPush.get("price")
          });
        }
      }

      dataProvider.addItems("optionalItems", itemsToSend);
    },

    accessoryLineChosenEventHandler : function() {
      this.getOptionalPackages();
    },

    tabShowEventHandler : function()  {
      this.get("stepEventAggregator").trigger("recalculation:request",this);
    },

    showRequestedOptionalPackage  : function(packageId) {
      var optionalPackage = _.filter(this.get("optionalPackages"), function(optionalPackage) {
        return optionalPackage.get("products").optionalPackageId === packageId;
      });
      if (optionalPackage.length>0) {
        optionalPackage[0].requestShow();
      }
    },

    deleteOptionalPackageProducts : function(packageId) {
      var optionalPackage = _.filter(this.get("optionalPackages"), function(optionalPackage) {
        return optionalPackage.get("products").optionalPackageId === packageId;
      });

      if (optionalPackage.length>0)
        optionalPackage[0].reset();
      this.get("stepEventAggregator").trigger("recalculation:request",this);
    },

    getOptionalPackages : function()  {
      var that                           = this;

      $.ajax({
        type        : "POST",
        datatype    : "json",
        contentType : "application/json",
        async       : false,
        url         : "/WizardService.svc/getOptionalPackagesBySystemId",
        data        : JSON.stringify({
          token           : window.BticinoS4B.token,
          systemId        : BticinoS4B.Instances.Models.ApplicationModel.get("systemId"),
          accessoryLineId : BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId")
        }),
        success     : function(data) {

          var optionalPackages        = data.packagesByOptionalPackageId;
          var optionalPackagesLength  = optionalPackages.length;

          for (var i=0; i<optionalPackagesLength; i++) {
            optionalPackages[i] = new optionalPackageModel({
              products : optionalPackages[i]
            });
          }

          optionalPackages = _.sortBy(optionalPackages, function(iterablePackage){
            var products                             = iterablePackage.get("products");
                products.packagesByOptionalPackageId = _.sortBy(products.packagesByOptionalPackageId, function(iterableItem){return Number(iterableItem.priority);});
            iterablePackage.set("products", products);

            if (Number(iterablePackage.get("products").optionalPackageId)>13 && Number(iterablePackage.get("products").optionalPackageId)<100)
              return -1;
            else
              return Number(iterablePackage.get("products").optionalPackageId);
          });


          that.set("optionalPackages", optionalPackages);
        }
      });
    },

    loadProject   : function(model) {

      var getProductModelToLoad         = function(packageClassId) {
        var optionalsToLoad       = model.optionals;
        var optionalsToLoadLength = (optionalsToLoad) ? optionalsToLoad.length : 0;
        for (var i=0; i<optionalsToLoadLength; i++) {
          if (optionalsToLoad[i].packageClassId === packageClassId) {
            return optionalsToLoad[i];
          }
        }
        return {};
      };

      var currentOptionalPackages       = this.get("optionalPackages");
      var optionalsToLoad               = model.optionals;
      if (currentOptionalPackages) {
        var currentOptionalPackagesLength = currentOptionalPackages.length;
        var productsLength, optionalToLoad;

        for (var i=0; i<currentOptionalPackagesLength; i++) {

          packages       = _.extend({}, currentOptionalPackages[i].get("products"));
          products       = packages.packagesByOptionalPackageId;
          productsLength = products.length;
          for (var j=0; j<productsLength; j++) {
            optionalToLoad = getProductModelToLoad(products[j].packageClassId);
            if (products[j].attributes)
              products[j].set(optionalToLoad);
            else
              products[j] = new optionalProductModel(_.extend(products[j], optionalToLoad));
          }
          currentOptionalPackages[i].set("products", packages);
        }
      }
    },

    deliverCurrent : function()  {
      var i=0, j=0, l=0, products, productsLength, packages, packagesLength;
      var consumptionIndicatorModel   = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");
      var optionalPackages            = this.get("optionalPackages"), optionalPackagesLength = optionalPackages ? optionalPackages.length : 0;
      var currentConsumption          = 0;

      for(i=0; i<optionalPackagesLength; i++) {
        products        = optionalPackages[i].get("products");
        packages        = products.packagesByOptionalPackageId;
        packagesLength  = packages.length;
        for (l=0; l<packagesLength; l++)
        {
          if  (
                (packages[l].get)&&
                (packages[l].get("specialVars"))&&
                (packages[l].get("specialVars")!=="")&&
                (packages[l].get("specialVars")!=="0")&&
                (packages[l].get("value"))
              ) {
            currentConsumption += packages[l].get("specialVars").currentConsumption*packages[l].get("value");
          }
        }
      }

      if (currentConsumption<0)
        consumptionIndicatorModel.addSupplyCurrent(currentConsumption);
      else
        consumptionIndicatorModel.addCurrentConsumption(currentConsumption);
    }
  });

  //Creating final materialOverview class
  var materialOverview                   = _.extend({}, RegularStep, {
    objClass    : "automationMaterialOverview",
    Views       : materialOverviewViews,
    Model       : materialOverviewModel
  });

  // Required, return the module for AMD compliance
  return materialOverview;

});